export const fetchWithAuthHeaders = (url, options = {}) => {
  const token = localStorage.getItem('token');
  const department = localStorage.getItem('department');

  const headers = new Headers(options.headers || {});
  headers.set('Accept', 'application/json');
  headers.set('Cache-Control', 'no-cache, no-store, must-revalidate');

  if (token) {
    headers.set('Authorization', 'Bearer ' + token);
  }

  if (department) {
    headers.set('FirehouseID', department);
  }

  return fetch(url, {
    ...options,
    headers,
  });
};

const nerisApiUrl = process.env.REACT_APP_NERIS_API_URL;

export const streamApi = {
  async streamIncidentsCoordinates(
    dateRange,
    searchQuery,
    startCallback,
    finallyCallback,
    onChunk,
    onLast
  ) {
    startCallback();
    const controller = new AbortController();
    const signal = controller.signal;

    const params = new URLSearchParams();

    if (dateRange) params.set('time', dateRange);
    if (searchQuery) params.set('search', searchQuery);

    const url = `${nerisApiUrl}/coordinates?${params.toString()}`;

    const response = await fetchWithAuthHeaders(url, { signal });

    // if (!response.ok) throw new Error('Failed to fetch stream data');

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    let buffer = '';
    // let firstResponseHandled = false;

    // if (!firstResponseHandled) {
    // onFirstResponce();
    // firstResponseHandled = true;
    // }

    while (true) {
      const { value, done } = await reader.read();
      if (done || signal.aborted) break;

      let tmp = decoder.decode(value, { stream: true });
      buffer += tmp;
      // console.log('Tmp: ', tmp);
      let lines = buffer.split('\n');
      buffer = lines.pop(); // Keep the last partial line

      for (const line of lines) {
        if (!line.trim()) continue;
        try {
          const obj = JSON.parse(line);
          // console.log('Incident:', obj);

          onChunk(obj);
          // handle obj...
        } catch (e) {
          console.error('JSON parse failed:', e, line);
        }
      }
    }

    finallyCallback();

    // Parse any remaining buffer
    if (buffer.trim()) {
      try {
        const obj = JSON.parse(buffer);

        console.log('Last incident:', obj);
        onLast(obj);
      } catch {}
    }

    return {
      abort: () => controller.abort(),
    };
  },
};
